import { z } from "zod";

/** Shared `?userId=` search for command-palette people actions. */
export const userIdSearchSchema = z.object({
	userId: z.string().min(1).optional().catch(undefined),
});

export type UserIdSearch = z.infer<typeof userIdSearchSchema>;
